var E;!function(E){E[E.FORCE_DISABLE=0]="FORCE_DISABLE",E[E.FORCE_ENABLE=1]="FORCE_ENABLE",E[E.CAN_SWITCH=2]="CAN_SWITCH"}(E||(E={}));var A=Symbol.for("XAxisDataShower");export{E as A,A as I};
